<div class="chat-wrapper">
  <div class="grid-desktop-1 chat-list" id="chat">
    @for (message of this.ticket?.messages; track message) {
      <app-chat-dialog appChatDialog [message]="message"></app-chat-dialog>
    }
  </div>
</div>
<div class="chat-input">
  <div class="input-wrapper" [class.not-able-to-reply]="!this.ticket?.customer_can_reply">
    @if (this.ticket?.customer_can_reply) {
      <textarea
        [formControl]="this.textAreaControl"
        id="resizableTextArea"
        rows="1"
        class="input autoExpand"
        placeholder="Typ hier je bericht"
      ></textarea>
    } @else {
      @if (this.ticket?.state_description === 'closed') {
        <span>Deze melding is gesloten, het is niet meer mogelijk om hierop te reageren.</span>
      }
    }
  </div>
  <app-button
    [icon]="(this.mobileService.isMobile() | async) ? 'send' : ''"
    (click)="submit()"
    [disabled]="this.form.invalid || !this.ticket?.customer_can_reply"
    onkeydown="">
    {{ (this.mobileService.isMobile() | async) ? '' : 'Verzenden' }}
  </app-button>
</div>
